const { styled, Box } = require("@mui/material");

const ColorBox = styled(Box)(({ theme, color }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  borderRadius: theme.spacing(0.5),
  backgroundColor: color,
}));

export { ColorBox };
